import React from 'react';
import styled from 'styled-components';

import { WrapLgMarginBottom } from 'App/global-style';
import { getMaxScreenWidths } from 'Utils/screenSizes.utils';
import { Breadcrumbs } from '../Breadcrumbs';
import { BreadcrumbsProps } from '../Breadcrumbs/Breadcrumbs';

type PageHeaderProps = BreadcrumbsProps & {
  pageTitle?: string;
  children?: React.ReactNode;
};

export const PageHeader = ({
  currentPage,
  pageTitle,
  children,
}: PageHeaderProps): React.ReactElement => {
  return (
    <>
      <Breadcrumbs currentPage={currentPage} />
      {children}
      <HeadingWrapper>
        <h1>{pageTitle}</h1>
        <HorizontalRuler />
      </HeadingWrapper>
    </>
  );
};

const HeadingWrapper = styled(WrapLgMarginBottom)`
  ${getMaxScreenWidths.tabletS} {
    margin-bottom: 32px;
  }

  ${getMaxScreenWidths.mobileXL} {
    margin-bottom: 24px;
  }
`;

const HorizontalRuler = styled.hr`
  border: none;
  width: 100%;
  height: 2px;
  color: #19191929; /* old IE */
  background-color: #19191929;
  margin-top: 16px;
`;
